import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { currentTheme } from '../../../global.variable';
import { AppService } from '../../app.service';
import { DataCheckService } from '../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../shared/services/loading-spinner.service';

@Component({
  selector: 'gtapp-external-app',
  templateUrl: './external-app.component.html',
  styleUrl: './external-app.component.scss',
  standalone: false,
})
export class ExternalAppComponent implements OnInit {
  currentTheme: string = currentTheme;
  showErrorMsg: any;
  showSuccessMsg: any;

  isSuperUser: any;

  s3FileInfo: any = {};

  constructor(
    private spinnerService: LoadingSpinnerService,
    private route: ActivatedRoute,
    private appService: AppService,
    private router: Router,
    private dataCheckService: DataCheckService,
  ) {}

  async ngOnInit(): Promise<void> {
    const swUpdate: any = this.appService.getSWUpdate();

    if (swUpdate?.isEnabled) {
      try {
        if (await swUpdate?.checkForUpdate()) {
          const updateApp = await swUpdate?.activateUpdate().then(() => {
            sessionStorage.removeItem('updateAvailable');
            window.location.reload();
          });
        } else {
          this.appService.appVersionCheck();
        }
      } catch (error) {
        throw error;
      }
    }

    setTimeout(() => {
      if (sessionStorage.getItem('updateAvailable') === 'true') {
        sessionStorage.removeItem('updateAvailable');
        window.location.reload();
      }
    }, 2000);
    // currently will catch only unblock account and stoping email alers urls.
    this.spinnerService.show();
    this.isSuperUser = this.dataCheckService.isSuperUser();
    this.s3FileInfo = {};
    var key = this.route.snapshot.paramMap.get('key');
    if (key) {
      this.appService
        .gtExternalLink('register_login/check_gt_link', {}, key, false)
        .then((response: any) => {
          if (response['status'] === 'success') {
            if (!response?.link_from) this.redirectDashBoard();

            if (response?.link_from === 'unblock_account') {
              localStorage.setItem('unblock_account', response?.message);
              this.redirectDashBoard();
            }
            if (
              response?.link_from === 'stop_mail_alerts' &&
              response?.message
            ) {
              this.showSuccessMsg = response?.message;
            }
            if (
              response?.link_from === 'download_file_from_s3' &&
              response?.data?.file_url
            ) {
              this.downloadS3File(
                response?.data?.file_url,
                response?.data?.file_name,
              );
              this.s3FileInfo = response?.data;
            }

            this.spinnerService.hide();
          } else {
            this.spinnerService.hide();
            this.showErrorMsg = response['message'];
            this.showSuccessMsg = undefined;
          }
          this.spinnerService.hide();
        });
    }
  }

  redirectDashBoard() {
    if (this.isSuperUser === true) {
      this.router.navigate(['gtadmin/dashboard']);
    } else {
      this.router.navigate(['/']);
    }
  }
  downloadS3File(url: string, fileName: string) {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName || 'download');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
